import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User, UserProfile } from '../../types/types';
import { RestUser } from '../../services/auth/types/user';

const initialState: AuthState = {
  isLoggedIn: false,
  user: null,
  userProfile: {
    avatar: '😊'
  },
  restUser: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<User>) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.userProfile = {
        avatar: '😊'
      };
      state.restUser = null;
      state.error = null;
    },
    updateUserProfile: (state, action: PayloadAction<Partial<UserProfile>>) => {
      state.userProfile = { ...state.userProfile, ...action.payload };
    },
    setRestUser: (state, action: PayloadAction<RestUser>) => {
      state.restUser = action.payload;
      // Update userProfile with REST user data
      const fullName = `${action.payload.firstName || ''} ${action.payload.lastName || ''}`.trim();
      state.userProfile = {
        ...state.userProfile,
        name: fullName || action.payload.email,
        email: action.payload.email,
        avatar: action.payload.avatarUrl || state.userProfile.avatar,
      };
    },
    updateRestUser: (state, action: PayloadAction<Partial<RestUser>>) => {
      if (state.restUser) {
        const updatedUser: RestUser = { ...state.restUser, ...action.payload };
        state.restUser = updatedUser;
        // Update userProfile accordingly
        const fullName = `${updatedUser.firstName || ''} ${updatedUser.lastName || ''}`.trim();
        state.userProfile = {
          ...state.userProfile,
          name: fullName || updatedUser.email,
          email: updatedUser.email,
          avatar: updatedUser.avatarUrl || state.userProfile.avatar,
        };
      }
    },
    clearRestUser: (state) => {
      state.restUser = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  updateUserProfile,
  setRestUser,
  updateRestUser,
  clearRestUser,
  clearError,
} = authSlice.actions;

export default authSlice.reducer; 